export default function createSizes()
{
  const sizes = {
    width: window.innerWidth,
    height: window.innerHeight,
    pixelRatio: Math.min(window.devicePixelRatio, 2),
    _callbacks: []
  }

  window.addEventListener('resize', () =>
  {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    sizes.pixelRatio = Math.min(window.devicePixelRatio, 2)

    sizes._callbacks.forEach((cb) => cb())
  })

  sizes.onResize = (cb) => sizes._callbacks.push(cb)

  return sizes
}
